import React from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '../ui/input';

export const PriceSearchModal = ({ open, onClose, priceQuery, setPriceQuery, filteredPriceResults }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-x-0 top-0 bottom-[65px] z-[9998] flex sm:inset-0 sm:items-center sm:justify-center sm:p-4" data-testid="price-search-modal">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative w-full sm:max-w-md lg:max-w-3xl bg-white sm:rounded-2xl flex flex-col h-full sm:h-auto sm:max-h-[75vh] shadow-2xl">
        <div className="px-4 pt-4 pb-2 flex items-center justify-between border-b border-gray-100">
          <h2 className="text-base font-bold text-gray-900">Fiyat Sorgula</h2>
          <button onClick={onClose} className="p-1.5 rounded-full hover:bg-gray-100">
            <X size={22} className="text-[#8E8E93]" />
          </button>
        </div>
        <div className="px-4 py-3">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8E8E93]" size={18} />
            <Input
              type="search"
              placeholder="Barkod veya ürün adı..."
              value={priceQuery}
              onChange={(e) => setPriceQuery(e.target.value)}
              className="pl-10 h-11 text-sm bg-[#F2F2F7] border-0 rounded-xl"
              autoFocus
              data-testid="price-search-input"
            />
          </div>
        </div>
        <div className="flex-1 overflow-y-auto px-4 pb-6">
          {priceQuery.length < 1 ? (
            <p className="text-center text-[#8E8E93] text-sm py-8">Barkod veya isim yazarak arayın</p>
          ) : filteredPriceResults.length > 0 ? (
            <div className="space-y-1">
              {filteredPriceResults.map((p) => (
                <div key={p.id} className="flex items-center justify-between px-3 py-2.5 bg-[#F2F2F7] rounded-xl" data-testid={`price-item-${p.id}`}>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-gray-900 truncate">{p.name}</p>
                    <div className="flex items-center gap-2">
                      {p.barcode && <span className="text-[10px] text-[#8E8E93]">{p.barcode}</span>}
                      <span className="text-[10px] text-[#8E8E93]">Stok: {p.current_stock}</span>
                    </div>
                  </div>
                  <span className="text-base font-bold text-[#34C759] shrink-0 ml-3">
                    {p.default_price > 0 ? `${p.default_price} TL` : '-'}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-[#8E8E93] text-sm py-8">Ürün bulunamadı</p>
          )}
        </div>
      </div>
    </div>
  );
};
